export default {
  name: 'FilePreviewComponent',
  props: {
    file: {
      type: Object,
      default: null
    },
    presigned_url: {
      type: String,
      default: ''
    },
    file_name: {
      type: String,
      default: ''
    },
    shared_access_level: {
      type: Object,
      default: null
    }
  },
  emits: ['close'],
  data: () => ({
    loading: true,
    preview_url: '',
    file_type: '',
    file_extension: '',
    internal_file_name: '',
    iframe_key: 0 // Add key to force iframe re-render
  }),
  computed: {
    can_download() {
      // Owners can always download
      if (!this.shared_access_level) return true;

      // Viewer = preview only
      return this.shared_access_level.name !== 'Viewer';
    }
  },

  mounted() {
    this.initialize_component();
  },
  methods: {
    initialize_component() {
      // Reset iframe key to force re-render
      this.iframe_key = 0;

      // Determine if we have a file object or direct URL
      if (this.file) {
        this.internal_file_name = this.file.name || this.file.file_name || '';
        this.preview_url = this.file.presigned_url || this.file.url || '';
      } else {
        this.internal_file_name = this.file_name;
        this.preview_url = this.presigned_url;
      }

      // Extract file extension and type
      this.extract_file_info();

      // Force iframe reload by updating key after a short delay
      setTimeout(() => {
        this.iframe_key++;
        this.loading = false;
      }, 100);
    },

    extract_file_info() {
      if (!this.internal_file_name) {
        // Try to extract from URL as fallback
        const url_parts = this.preview_url.split('/');
        this.internal_file_name = url_parts[url_parts.length - 1].split('?')[0];
      }

      // Get file extension
      const name_parts = this.internal_file_name.split('.');
      this.file_extension = name_parts.length > 1
        ? name_parts[name_parts.length - 1].toLowerCase()
        : '';

      // Set file type (same as extension for simplicity)
      this.file_type = this.file_extension;
    },

    close_file_preview_modal() {
      this.$emit('close');
    }
  }
};